// 「条件をリセット」ボタンの処理。
// 入力値をクリアしたうえでフォームを送信し、絞り込み無しの一覧をサーバから取り直す。
// クリアだけで送信しないと、サーバ側の絞り込みは前回のまま残り一覧が更新されない。
function clearSelectionForm(button) {
  // テキスト入力フォームの値をクリア
  document.getElementById('project_title').value = '';
  // 債権者・債務者フィールドはログイン時のみ表示されるためnullチェック
  const creditorName = document.getElementById('creditor_name');
  if (creditorName) creditorName.value = '';
  const debtorName = document.getElementById('debtor_name');
  if (debtorName) debtorName.value = '';

  // プルダウンの選択をクリア（先頭の項目を選択状態に）
  document.getElementById('status').tomselect.setValue('');
  document.getElementById('legal_type').tomselect.setValue('');

  // クリア後の空の条件で再検索する。
  // フォームは page を持たないため、送信すると1ページ目に戻る。
  button.form.requestSubmit();
}

// onclick属性から呼び出せるように、関数をグローバルスコープに設定
window.clearSelectionForm = clearSelectionForm;
